import {
    Box,
    Center,
    Text,
    Stack,
    List,
    ListItem,
    ListIcon,
    VStack,
    Heading,
    Button,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { FcApproval } from 'react-icons/fc';
  
  export default function Pricing() {
    return (
      <Center py={6}>
        <VStack>
        <Heading marginBottom={5}>Pricing and Services</Heading>
        <Box
          maxW={'330px'}
          w={'full'}
          bg={useColorModeValue('white', 'gray.800')}
          boxShadow={'2xl'}
          rounded={'md'}
          overflow={'hidden'}>
          <Stack
            textAlign={'center'}
            p={6}
            color={useColorModeValue('gray.800', 'white')}
            align={'center'}>
                
            <Text
              fontSize={'sm'}
              fontWeight={500}
              bg={useColorModeValue('red.50', 'red.900')}
              p={2}
              px={3}
              color={'red.500'}
              rounded={'full'}>
              Starts At
            </Text>
            <Stack direction={'row'} align={'center'} justify={'center'}>
              <Text fontSize={'3xl'}>$</Text>
              <Text fontSize={'6xl'} fontWeight={800}>
                500
              </Text>
              <Text color={'gray.500'}>/month</Text>
            </Stack>
          </Stack>
  
          <Box bg={useColorModeValue('gray.50', 'gray.900')} px={6} py={10}>
            <List spacing={3}>
              <ListItem>
                <ListIcon as={FcApproval} color="green.400" />
                Website Design
              </ListItem>
              <ListItem>
                <ListIcon as={FcApproval} color="green.400" />
                SEO / SEM
              </ListItem>
              <ListItem>
                <ListIcon as={FcApproval} color="green.400" />
                Digital Marketing Strategy
              </ListItem>
              <ListItem>
                <ListIcon as={FcApproval} color="green.400" />
                Paid Advertising + more
              </ListItem>
            </List>
  
            <Button
              mt={10}
              w={'full'}
              bg={'red.400'}
              color={'white'}
              rounded={'xl'}
              boxShadow={'0 5px 20px 0px rgb(191 82 82 / 60%)'}
              _hover={{
                bg: 'red.500',
              }}
              _focus={{
                bg: 'red.500',
              }}>
              Start your trial
            </Button>
          </Box>
        </Box>
        </VStack>
      </Center>
    );
  }